import { useProvider } from "@react-spectrum/provider";
import _react from "react";
import { filterDOMProps } from "@react-aria/utils";
import { baseStyleProps, classNames, useSlotProps, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/icon/vars.css
var $e0403de4450d623122b2d93055f70571$exports = {};
$e0403de4450d623122b2d93055f70571$exports = {
  "spectrum-Icon": "_spectrum-Icon_8ac98",
  "spectrum-UIIcon": "_spectrum-UIIcon_8ac98",
  "spectrum-Icon--sizeXXS": "_spectrum-Icon--sizeXXS_8ac98",
  "spectrum-Icon--sizeXS": "_spectrum-Icon--sizeXS_8ac98",
  "spectrum-Icon--sizeS": "_spectrum-Icon--sizeS_8ac98",
  "spectrum-Icon--sizeM": "_spectrum-Icon--sizeM_8ac98",
  "spectrum-Icon--sizeL": "_spectrum-Icon--sizeL_8ac98",
  "spectrum-Icon--sizeXL": "_spectrum-Icon--sizeXL_8ac98",
  "spectrum-Icon--sizeXXL": "_spectrum-Icon--sizeXXL_8ac98",
  "spectrum--medium": "_spectrum--medium_8ac98",
  "spectrum-UIIcon--large": "_spectrum-UIIcon--large_8ac98",
  "spectrum-UIIcon--medium": "_spectrum-UIIcon--medium_8ac98",
  "spectrum--large": "_spectrum--large_8ac98",
  "spectrum-UIIcon-AlertMedium": "_spectrum-UIIcon-AlertMedium_8ac98",
  "spectrum-UIIcon-AlertSmall": "_spectrum-UIIcon-AlertSmall_8ac98",
  "spectrum-UIIcon-ArrowDownSmall": "_spectrum-UIIcon-ArrowDownSmall_8ac98",
  "spectrum-UIIcon-ArrowLeftMedium": "_spectrum-UIIcon-ArrowLeftMedium_8ac98",
  "spectrum-UIIcon-Asterisk": "_spectrum-UIIcon-Asterisk_8ac98",
  "spectrum-UIIcon-CheckmarkMedium": "_spectrum-UIIcon-CheckmarkMedium_8ac98",
  "spectrum-UIIcon-CheckmarkSmall": "_spectrum-UIIcon-CheckmarkSmall_8ac98",
  "spectrum-UIIcon-ChevronDownMedium": "_spectrum-UIIcon-ChevronDownMedium_8ac98",
  "spectrum-UIIcon-ChevronDownSmall": "_spectrum-UIIcon-ChevronDownSmall_8ac98",
  "spectrum-UIIcon-ChevronLeftLarge": "_spectrum-UIIcon-ChevronLeftLarge_8ac98",
  "spectrum-UIIcon-ChevronLeftMedium": "_spectrum-UIIcon-ChevronLeftMedium_8ac98",
  "spectrum-UIIcon-ChevronRightLarge": "_spectrum-UIIcon-ChevronRightLarge_8ac98",
  "spectrum-UIIcon-ChevronRightMedium": "_spectrum-UIIcon-ChevronRightMedium_8ac98",
  "spectrum-UIIcon-ChevronRightSmall": "_spectrum-UIIcon-ChevronRightSmall_8ac98",
  "spectrum-UIIcon-ChevronUpSmall": "_spectrum-UIIcon-ChevronUpSmall_8ac98",
  "spectrum-UIIcon-CornerTriangle": "_spectrum-UIIcon-CornerTriangle_8ac98",
  "spectrum-UIIcon-CrossLarge": "_spectrum-UIIcon-CrossLarge_8ac98",
  "spectrum-UIIcon-CrossMedium": "_spectrum-UIIcon-CrossMedium_8ac98",
  "spectrum-UIIcon-CrossSmall": "_spectrum-UIIcon-CrossSmall_8ac98",
  "spectrum-UIIcon-DashSmall": "_spectrum-UIIcon-DashSmall_8ac98",
  "spectrum-UIIcon-DoubleGripper": "_spectrum-UIIcon-DoubleGripper_8ac98",
  "spectrum-UIIcon-FolderBreadcrumb": "_spectrum-UIIcon-FolderBreadcrumb_8ac98",
  "spectrum-UIIcon-HelpMedium": "_spectrum-UIIcon-HelpMedium_8ac98",
  "spectrum-UIIcon-HelpSmall": "_spectrum-UIIcon-HelpSmall_8ac98",
  "spectrum-UIIcon-InfoMedium": "_spectrum-UIIcon-InfoMedium_8ac98",
  "spectrum-UIIcon-InfoSmall": "_spectrum-UIIcon-InfoSmall_8ac98",
  "spectrum-UIIcon-Magnifier": "_spectrum-UIIcon-Magnifier_8ac98",
  "spectrum-UIIcon-SkipLeft": "_spectrum-UIIcon-SkipLeft_8ac98",
  "spectrum-UIIcon-SkipRight": "_spectrum-UIIcon-SkipRight_8ac98",
  "spectrum-UIIcon-Star": "_spectrum-UIIcon-Star_8ac98",
  "spectrum-UIIcon-StarOutline": "_spectrum-UIIcon-StarOutline_8ac98",
  "spectrum-UIIcon-SuccessMedium": "_spectrum-UIIcon-SuccessMedium_8ac98",
  "spectrum-UIIcon-SuccessSmall": "_spectrum-UIIcon-SuccessSmall_8ac98",
  "spectrum-UIIcon-TripleGripper": "_spectrum-UIIcon-TripleGripper_8ac98"
};

function $c16bb541c700d2636376eacdb51461d4$var$iconColorValue(value) {
  return "var(--spectrum-semantic-" + value + "-color-icon)";
}

const $c16bb541c700d2636376eacdb51461d4$var$iconStyleProps = _babelRuntimeHelpersEsmExtends({}, baseStyleProps, {
  color: ['color', $c16bb541c700d2636376eacdb51461d4$var$iconColorValue]
});
/**
 * Spectrum icons are clear, minimal, and consistent across platforms. They follow the focused and rational principles of the design system in both metaphor and style.
 */


var $e0403de4450d623122b2d93055f70571$$interop$default = $parcel$interopDefault($e0403de4450d623122b2d93055f70571$exports);
export function Icon(props) {
  props = useSlotProps(props, 'icon');

  let {
    children,
    size,
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children", "size", "aria-label", "aria-hidden"]);

  let {
    styleProps
  } = useStyleProps(otherProps, $c16bb541c700d2636376eacdb51461d4$var$iconStyleProps);
  let provider = useProvider();
  let scale = 'M';

  if (provider !== null) {
    scale = provider.scale === 'large' ? 'L' : 'M';
  }

  if (!ariaHidden) {
    ariaHidden = undefined;
  } // Use user specified size, falling back to provider scale if size is undef


  let iconSize = size ? size : scale;
  return _react.cloneElement(children, _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), styleProps, {
    focusable: 'false',
    'aria-label': ariaLabel,
    'aria-hidden': ariaLabel ? ariaHidden || undefined : true,
    role: 'img',
    className: classNames($e0403de4450d623122b2d93055f70571$$interop$default, children.props.className, 'spectrum-Icon', "spectrum-Icon--size" + iconSize, styleProps.className)
  }));
}
export function UIIcon(props) {
  props = useSlotProps(props, 'icon');

  let {
    children,
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children", "aria-label", "aria-hidden"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let provider = useProvider();
  let scale = 'M';

  if (provider !== null) {
    scale = provider.scale === 'large' ? 'L' : 'M';
  }

  if (!ariaHidden) {
    ariaHidden = undefined;
  }

  return _react.cloneElement(children, _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), styleProps, {
    scale,
    focusable: 'false',
    'aria-label': ariaLabel,
    'aria-hidden': ariaLabel ? ariaHidden || undefined : true,
    role: 'img',
    className: classNames($e0403de4450d623122b2d93055f70571$$interop$default, children.props.className, 'spectrum-Icon', {
      ["spectrum-UIIcon-" + children.type['displayName']]: children.type['displayName']
    }, styleProps.className)
  }));
}
//# sourceMappingURL=module.js.map
